import React, { useEffect, useState } from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { UrgencySection } from '../components/UrgencySection';
import { FaqSection } from '../components/FaqSection';
import { StickyCta } from '../components/StickyCta';
import { Footer } from '../components/Footer';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL } from '../data/content';
type SalesPageProps = {
  offerMinutes: number;
  copiesTotal: number;
  copiesClaimed: number;
  showStickyCta: boolean;
};
export function SalesPage({
  offerMinutes,
  copiesTotal,
  copiesClaimed,
  showStickyCta
}: SalesPageProps) {
  const [scrolled, setScrolled] = useState(false);
  const countdown = useCountdown(offerMinutes * 60);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="min-h-screen w-full bg-ink-950 font-sans text-white" data-id="element-155" data-mp="35t00l4ljjk7d">
      <Hero checkoutUrl={CHECKOUT_URL} countdown={countdown} data-id="element-156" data-mp="35qx5451mcyv9" />
      <main data-id="element-157" data-mp="30uyhijo47kvw">
        <PainSection data-id="element-158" data-mp="30uge9331c6eh" />
        <SolutionSection checkoutUrl={CHECKOUT_URL} data-id="element-159" data-mp="30ru5x18blmv7" />
        <UrgencySection checkoutUrl={CHECKOUT_URL} countdown={countdown} claimed={copiesClaimed} total={copiesTotal} data-id="element-160" data-mp="2vvvfl83flus5" />
        <FaqSection data-id="element-161" data-mp="3ojr800lyx0j4" />
      </main>
      <Footer data-id="element-162" data-mp="3okj5xi31fack" />

      {showStickyCta && scrolled && <div className="h-20" aria-hidden="true" data-id="element-163" data-mp="3ohom9srultk7" />}
      <StickyCta visible={showStickyCta && scrolled} checkoutUrl={CHECKOUT_URL} countdown={countdown} data-id="element-164" data-mp="3jjdc1gxn5h1g" />
    </div>;
}